export default {
  methods: {
    isEventUnsubscribable(event) {
      if (!event || !event.currentUserRegistrationStatus) return false;
      return event.currentUserRegistrationStatus === 'Registration active' || event.currentUserRegistrationStatus === 'Waiting';
    },
    getCookieValue(name) {
      const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return value ? value.pop() : '';
    },
    getEventName(event) {
      return (event.Display_Name__c) ? event.Display_Name__c : event.name;
    },
    formatDate(date, string) {
      return this.$options.filters.customFormatDate(date, string);
    },
    dateLabel(label, date, format) {
      return `${this.translate(label)}: ${this.formatDate(date, format)}`;
    },
    getCrops(crops) {
      if (!crops || !window.KWS.projectCrops) return;
      const filteredCrops = [];
      crops.split(';').forEach((crop) => {
        const filteredCrop = window.KWS.projectCrops.find(
          (entry) => entry.key === crop,
        );
        filteredCrops.push(filteredCrop);
      });
      this.crops = filteredCrops.filter((crop) => !!crop);
    },
    getLinkToEventDetailView(id) {
      return this.detailView ? `${this.detailView}?event=${id}` : '#';
    },
    getLinkToEventParticipantsView(id) {
      return this.participantsView ? `${this.participantsView}?event=${id}` : '#';
    },
    getEventWithAdditionalContentFor(event) {
      if (!window.KWS.additionalContentForSalesforceEvents) return event;
      const findEventWithSameIdComparator = (additionalContent) => additionalContent.id === event.id;
      const additionalContentForEvent = window.KWS.additionalContentForSalesforceEvents.find(findEventWithSameIdComparator);
      if (!additionalContentForEvent) return event;
      return Object.assign(event, additionalContentForEvent);
    },
    async getEventData(url) {
      this.error = null;
      this.loading = true;
      return this.$http
        .get(url, {
          withCredentials: true,
          headers: {
            Authorization: `${this.getCookieValue('Authorization')}`,
            'Content-Type': 'application/json',
          },
        })
        .catch((err) => {
          this.error = this.translate('lblApiError');
          console.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    renameObjectKeys(object) {
      const mapping = {
        City__c: 'city',
        Country_Code__c: 'countryCode',
        Crops__c: 'crops',
        EndDate: 'endDate',
        EventActiveMembersCount__c: 'activeMembersCount',
        EventCancelledMembersCount__c: 'cancelledMembersCount',
        EventFreeCapacity__c: 'freeCapacity',
        EventTotalCapacity__c: 'totalCapacity',
        EventWaitingMembersCount__c: 'waitingMembersCount',
        Id: 'id',
        Name: 'name',
        Postal_Code__c: 'postalCode',
        Registration_Deadline__c: 'registrationDeadline',
        StartDate: 'startDate',
        State_Province__c: 'stateProvince',
        Street__c: 'street',
        Description: 'description',
      };

      const mapped = Object.keys(object).reduce(
        (acc, key) => ({
          ...acc,
          ...{ [mapping[key] || key]: object[key] },
        }),
        {},
      );

      mapped.locationHref = mapped.postalCode
        ?? mapped.city
        ?? mapped.street
        ? `https://www.google.de/maps/search/${mapped.street},+${mapped.postalCode}+${mapped.city}` : null;

      return mapped;
    },
  },
};
